import React from 'react';

/*eslint-disable */
var combinedShapeIcon = (function (_ref) {
  var alt = _ref.alt;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("title", null, alt), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M15.577 10.094l.07.838v.21a7.81 7.81 0 0 1-7.823 7.823C3.493 19 0 15.507 0 11.176c-.035-4.33 3.458-7.823 7.789-7.823h.873v6.74h6.915zm-7.788 7.16c3.108 0 5.693-2.34 6.042-5.414H6.916V5.169c-3.004.42-5.204 3.004-5.204 6.007a6.081 6.081 0 0 0 6.077 6.077zm11.176-9.71l.035.908h-8.697V0h.874c4.226 0 7.683 3.353 7.788 7.544zm-6.915-.838v.035h5.099a6.004 6.004 0 0 0-5.1-4.925v4.89z"
  }));
});

export { combinedShapeIcon as default };
